<!-- Header Component - Header Information -->
<div class="f1065-k2-container">

  <!-- INITIAL LOADING STATE - shown when waiting for filter selection -->
  @if (loadingData) {
<div class="gg-loader">
    <div class="gg-loader-text">
      <img src="assets/img/arrow-filter-sm.png" alt="">
    </div>
  </div>
}

  <!-- MAIN CONTENT - shown after initialization -->
  @if (!loadingData) {
<div>
    
    <!-- FORM LOADER - shown while fetching data after filter selection -->
    @if (showLoader) {
<div class="form-loader">
      <div class="css-spinner"></div>
    </div>
}

    <!-- FORM CONTENT -->
    @if (!showLoader) {
<div>
    <!-- Section Header -->
    <p class="h5 section-header">
      <b>{{ sectionHeader }}</b>
    </p>

    <div class="table-responsive">
      <!-- SECTION 1 (UI_S1) - TEXT and CHK_BX -->
      @if (hasSection('UI_S1')) {
<table class="table table-striped blue tbl-cus-width">
        <thead>
          <tr align="center">
            @if (showErrCol) {
<th style="width: 200px;">Error</th>
}
            <th class="hd-sno" style="text-align: center">Line</th>
            <th style="text-align: center">Description</th>
            @for (cols of getColHeadersForSection('UI_S1'); track trackByColHeader($index, cols)) {
<th
                style="width:120px; text-align: center; vertical-align: top;">
              {{ cols.COL_DESC }}
              @if (cols.IS_MANDATORY === 'Y') {
<span>*</span>
}
            </th>
}
          </tr>
        </thead>
        <tbody>
          @for (x of getRowsForSection('UI_S1') | orderBy:['LINE_ORDER', 'SNO']; track trackByLine($index, x)) {
<tr>
            <!-- Error Column -->
            @if (showErrCol) {
<td class="err-col">
              <div [ngClass]="x.ERR_MSG && x.ERR_MSG.length > 0 ? 'err-cell-yes' : 'err-cell-no'"
                   [innerHTML]="x.ERR_MSG">
              </div>
            </td>
}

            <!-- Line Number with Add/Delete buttons -->
            <td style="font-weight:bold; white-space: nowrap; padding-right: 5px; text-align: right;">
              @if (x.SNO === 0 && x.IS_LINE_MULTI === 'Y') {
<i
                 style="font-size:24px; cursor: pointer; vertical-align: middle;"
                 class="fa fa-plus-circle color-green"
                 ap-tooltip [tooltipContent]="'Add Row'"
                 [direction]="'top'" [appendAfterTarget]="true"
                 (click)="addRow(x)"></i>
}
              @if (x.SNO > 0) {
<i
                 style="font-size:24px; cursor: pointer; vertical-align: middle;"
                 class="fa fa-minus-circle color-red"
                 ap-tooltip [tooltipContent]="'Delete Row'"
                 [direction]="'top'" [appendAfterTarget]="true"
                 (click)="deleteRow(x)"></i>
}
              @if (x.SNO === 0) {
<span>{{ x.LINE_NO }}</span>
}
            </td>

            <!-- Description -->
            <td><p>{{ x.SNO === 0 ? x.LINE_DESC : '' }}</p></td>

            <!-- Data Cells -->
            @for (amts of x.items | orderBy:'COL_ORDER'; track trackByCol($index, amts)) {
<td
                style="height: 30px; width:120px; text-align: right;">
              
              <!-- Hidden ADJ_KEY -->
              <input type="hidden" [value]="amts.ADJ_KEY">

              <!-- TEXT -->
              @if (amts.UI_COMP === 'TEXT') {
<input
                     type="text"
                     class="form-control min-ele-wid"
                     [ngClass]="{
                       'custom-error': amts.IS_ERROR === 'Y',
                       'custom-textbox': amts.IS_ENABLED === 'Y' || amts.IS_ENABLED === 'Z'
                     }"
                     [(ngModel)]="amts.CELL_VALUE"
                     [disabled]="amts.IS_ENABLED === 'N'"
                     [maxlength]="amts.MAX_LENGTH"
                     style="text-align: right;">
}

              <!-- CHECK BOX (uses '1'/'0') -->
              @if (amts.UI_COMP === 'CHK_BX') {
<input
                     type="checkbox"
                     class="lg-chk"
                     [ngModel]="amts.CELL_VALUE === '1'"
                     (ngModelChange)="amts.CELL_VALUE = $event ? '1' : '0'"
                     [disabled]="amts.IS_ENABLED === 'N'">
}
            </td>
}
          </tr>
}
        </tbody>
      </table>
}

      <!-- SECTION 2 (UI_S2) - NUMERIC, TEXT, CHK_BX, DATE, DROP_DOWN -->
      <table class="table table-striped blue tbl-cus-width">
        <thead>
          <tr align="center">
            <th class="hd-sno" style="text-align: center">Line</th>
            <th style="text-align: center">Description</th>
            @for (cols of getColHeadersForSection('UI_S2'); track trackByColHeader($index, cols)) {
<th
                style="width:120px; text-align: center; vertical-align: top;">
              {{ cols.COL_DESC }}
              @if (cols.IS_MANDATORY === 'Y') {
<span>*</span>
}
            </th>
}
          </tr>
        </thead>
        <tbody>
          @for (x of getRowsForSection('UI_S2') | orderBy:['LINE_ORDER', 'SNO']; track trackByLine($index, x)) {
<tr>
            <!-- Line Number with Add/Delete buttons -->
            <td style="font-weight:bold; white-space: nowrap; padding-right: 5px; text-align: right;">
              @if (x.SNO === 0 && x.IS_LINE_MULTI === 'Y') {
<i
                 style="font-size:24px; cursor: pointer; vertical-align: middle;"
                 class="fa fa-plus-circle color-green"
                 ap-tooltip [tooltipContent]="'Add Row'"
                 [direction]="'top'" [appendAfterTarget]="true"
                 (click)="addRow(x)"></i>
}
              @if (x.SNO > 0) {
<i
                 style="font-size:24px; cursor: pointer; vertical-align: middle;"
                 class="fa fa-minus-circle color-red"
                 ap-tooltip [tooltipContent]="'Delete Row'"
                 [direction]="'top'" [appendAfterTarget]="true"
                 (click)="deleteRow(x)"></i>
}
              @if (x.SNO === 0) {
<span>{{ x.LINE_NO }}</span>
}
            </td>

            <!-- Description -->
            <td><p>{{ x.SNO === 0 ? x.LINE_DESC : '' }}</p></td>

            <!-- Data Cells -->
            @for (amts of x.items | orderBy:'COL_ORDER'; track trackByCol($index, amts)) {
<td
                style="height: 30px; width:120px; text-align: right;">
              
              <!-- Hidden ADJ_KEY -->
              <input type="hidden" [value]="amts.ADJ_KEY">

              <!-- NUMERIC -->
              @if (amts.UI_COMP === 'NUMERIC') {
<input
                     type="text"
                     class="form-control min-ele-wid"
                     [ngClass]="{
                       'custom-error': amts.IS_ERROR === 'Y',
                       'custom-textbox': amts.IS_ENABLED === 'Y' || amts.IS_ENABLED === 'Z'
                     }"
                     [(ngModel)]="amts.CELL_VALUE"
                     [disabled]="amts.IS_ENABLED === 'N'"
                     [readonly]="isLastNumericColumn(x.items, amts)"
                     onlyIntegersWithLength
                     (ngModelChange)="calcTotalsCol(x.items)"
                     style="text-align: right;">
}

              <!-- TEXT -->
              @if (amts.UI_COMP === 'TEXT') {
<input
                     type="text"
                     class="form-control min-ele-wid"
                     [ngClass]="{
                       'custom-error': amts.IS_ERROR === 'Y',
                       'custom-textbox': amts.IS_ENABLED === 'Y' || amts.IS_ENABLED === 'Z'
                     }"
                     [(ngModel)]="amts.CELL_VALUE"
                     [disabled]="amts.IS_ENABLED === 'N'"
                     [maxlength]="amts.MAX_LENGTH"
                     style="text-align: right;">
}

              <!-- CHECK BOX (uses '1'/'0') -->
              @if (amts.UI_COMP === 'CHK_BX') {
<input
                     type="checkbox"
                     class="lg-chk"
                     [ngModel]="amts.CELL_VALUE === '1'"
                     (ngModelChange)="amts.CELL_VALUE = $event ? '1' : '0'"
                     [disabled]="amts.IS_ENABLED === 'N'">
}

              <!-- DATE: ENABLED -->
              @if (amts.UI_COMP === 'DATE' && amts.IS_ENABLED !== 'N') {
<div class="date-input-group">
                <input type="date"
                       class="form-control min-ele-wid"
                       [ngClass]="{
                         'custom-error': amts.IS_ERROR === 'Y',
                         'custom-textbox': amts.IS_ENABLED === 'Y' || amts.IS_ENABLED === 'Z'
                       }"
                       [ngModel]="amts.CELL_VALUE | date:'yyyy-MM-dd'"
                       (ngModelChange)="onDateChange(amts, $event)"
                       placeholder="yyyy-mm-dd"
                       style="font-size: 11px;">
              </div>
}

              <!-- DATE: DISABLED -->
              @if (amts.UI_COMP === 'DATE' && amts.IS_ENABLED === 'N') {
<div class="date-input-group">
                <input type="date"
                       class="form-control min-ele-wid"
                       [ngClass]="{'custom-error': amts.IS_ERROR === 'Y'}"
                       [ngModel]="amts.CELL_VALUE | date:'yyyy-MM-dd'"
                       disabled
                       readonly
                       placeholder="yyyy-mm-dd"
                       style="font-size: 11px;">
              </div>
}

              <!-- DROPDOWN -->
              @if (amts.UI_COMP === 'DROP_DOWN') {
<select
                      class="form-control min-ele-wid k2-select"
                      [ngClass]="{
                        'custom-error': amts.IS_ERROR === 'Y',
                        'custom-textbox': amts.IS_ENABLED === 'Y' || amts.IS_ENABLED === 'Z'
                      }"
                      [(ngModel)]="amts.CELL_VALUE"
                      [disabled]="amts.IS_ENABLED === 'N'">
                <option value="">--Select--</option>
                @for (opt of amts.actionData; track $index) {
<option [value]="opt.VALUE">{{ opt.LABEL }}</option>
}
              </select>
}
            </td>
}
          </tr>
}
        </tbody>
      </table>
    </div>

    <!-- Buttons -->
    @if (isAdmin) {
<div class="k2-buttons-container">
      <button class="save-button" type="button" (click)="saveData()" [disabled]="isSaveClicked">Save</button>
      <button class="reset-button" type="button" (click)="reset()" [disabled]="!isAdmin">Reset</button>
    </div>
}
    </div>
} <!-- closes content -->
  </div>
} <!-- closes !loadingData -->
</div> <!-- closes f1065-k2-container -->

<!-- Confirmation Modal -->
@if (showConfirmModal) {
<div class="confirmation-modal-overlay">
  <gtw-confirmation-modal
    [config]="confirmModalConfig"
    [visible]="false"
    (confirmed)="onConfirmSave(true)"
    (cancelled)="onConfirmSave(false)"
    (closed)="onConfirmSave(false)">
  </gtw-confirmation-modal>
</div>
}
